import { render, staticRenderFns } from "./EpisodesListNavItem.vue?vue&type=template&id=43024f44&"
import script from "./EpisodesListNavItem.vue?vue&type=script&lang=js&"
export * from "./EpisodesListNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports